import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from '../../../app.config';

@Injectable()
export class ContactsService {
    private urlGetContacts: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetContacts = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetContacts';
    }

    getContacts(): Observable<any> {
        return this.http.get(this.urlGetContacts)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/contact/services/contact.service.ts